import chairSvg from '../assets/chair.svg?raw';
import ChairIcon from '../../../assets/icons/chair.svg?react';
import { defineSketchObjectType, registerSketchObjectType } from '../registry';
import { SketchObjectAnchorKind, SketchObjectCategory } from '../types';
import { t } from '../../translation/markers';

registerSketchObjectType(
  defineSketchObjectType({
    id: 'chair',
    label: t('Chair'),
    category: SketchObjectCategory.FURNITURE,
    anchor: SketchObjectAnchorKind.POINT,
    constraint: { kind: 'FREE' },
    defaultSize: { width: 0.45, depth: 0.45 },
    params: {},
    glyph: { kind: 'svg', assetKey: 'chair', svgSource: chairSvg },
    icon: ChairIcon,
  }),
);
